<template>
  <tender-form-label :key="index"
    :label="options.Name"
    :prop="options.Key"
    :rules="rules"
  >
    <bear-time-select 
      v-model="form[options.Key]" 
      :attrs="attrs" 
      :options="options"
      @change="selectChangeHandle"
    ></bear-time-select>
  </tender-form-label>
</template>
<script>
import BearTimeSelect from '~@/time-select/src'
import { mixForFormItem } from "../../../js/mixins"
import utils from '../../../js/utils'
export default {
  name: 'FormSelectTime',
  mixins: [mixForFormItem],
  components: {BearTimeSelect},
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options = {}} = this
      let {Key, Value} = options
      let {trueValue} = this.param
      utils.readyToSetFormItemDefault(form, options).then(() => {
        if(trueValue) {
          form[`select_${Key}`] = Value || ''
          form[Key] = Value === trueValue
        } else {
          form[Key] = Value || ''
        }
      }).catch(() => null)
    },
    selectChangeHandle(value) {
      let {form = {}, options = {}} = this
      let {Key} = options
      let {trueValue} = this.param
      if(trueValue) {
        form[`select_${Key}`] = value
        form[Key] = value === trueValue
      } else {
        form[Key] = value
      }
      this.doValidate()
    }
  }

}
</script>
<style>

</style>